import { isIP } from "is-ip"


function getHtmlOrigin(){
    if(typeof window === "undefined")return ""
    if(!isIP(window.location.hostname))return window.location.origin + "/"
    return `${window.location.protocol}://${window.location.hostname}:5173/`
}
class Env{
    htmlOrigin:string = getHtmlOrigin()
}
export const env = new Env()